export { default } from './ViewVehiclesModal';
